export default __webpack_public_path__ + "62d45789345be6124aa3666c94e962f6.png";